// @flow
import React, { Component } from 'react'
import moment from "moment"
import { getOptionBookList } from '../../actions/optionbook'
import { StyledOptonHader } from './style'
import OptionBookView from "./option-book-view"
import { Spin, Card, InputNumber, DatePicker, Collapse, Select, Table, Button, Icon } from 'antd'
import Sticky from 'react-stickynode';
const Option = Select.Option;
const Panel = Collapse.Panel;

type State = {
  optionBooks: Object[]
}

class OptionBook extends Component<Props> {

  state: State = {
    optionBooks: [],
    isLoading: true,
    dataCount: 'all',
    collapseKey: 0,
    onDate: moment(),
    tableData: [],
    isTradeBuilder: false,
  }

  onCollapse = (key1) => {
    const { dataCount } = this.state
    if(!key1) {
      return;
    }
    const pageSize = dataCount === 'all' ? 0 : parseInt(dataCount, 10) / 2
    const key = parseInt(key1, 10) - 1;
    const optionBooks = this.state.optionBooks[key] && this.state.optionBooks[key].asStraddles || []
    let nearestIndex = optionBooks.reduce( (r, a, i, aa) => {
      return i && Math.abs(aa[r].strike - this.state.stockPrice) < Math.abs(a.strike - this.state.stockPrice) ? r : i ;
    }, -1);
    let nearestIndex1 = nearestIndex + pageSize;
    this.setState({
      collapseKey: key,
      nearestIndex: nearestIndex1
    }, () => {
        const id = document.getElementById('book-list');
        if(id && nearestIndex > 0) {
          id.scrollTo(0, nearestIndex*20)
        }
    })

  }

  componentDidMount() {
    this.loadData(this.state.onDate);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.symbol !== this.props.symbol) {
      this.loadData();
    }
  }

  loadData = async (date) => {
    this.setState({
      isLoading: true,
    })
    const list = await getOptionBookList(this.props.symbol, moment(date).format("YYYY-MM-DD"))
    const newState = {isLoading: false}
    if(list && list.data && list.data.data && list.data.data.securities &&
      list.data.data.securities.options && list.data.data.securities.options.optionBook
      && list.data.data.securities.options.optionBook.series) {
      newState.optionBooks = list.data.data.securities.options.optionBook.series || [];
      newState.stockPrice = list.data.data.securities.options.optionBook.price || [];
    } else {
      newState.optionBooks = [];
      newState.stockPrice = [];
    }
    this.setState({
      ...newState
    })
  }

  handleDataShow = (value) => {
    this.setState({
      dataCount: value
    });
  }

  onChangeDate = (onDate) => {
    this.setState({
      onDate,
    });
    this.loadData(onDate);
  }
  
  onChangeTransactionValues = (name, value, index) => {
    let tableData = this.state.tableData;
    tableData[index] = {
      ... tableData[index],
      [name]: value,
    }
    this.setState({
      tableData,
    })
  }
  
  editCell = (editIndex, editField) => {
    this.setState({
      editIndex,
      editField
    })
  }
  
  getColumns = () => {
    const {editIndex, editField} = this.state;
    return [{
      title: 'Side',
      dataIndex: 'side',
      width: '14%',
      key: 'side',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'side') {
          return <Select defaultValue={text} value={text} onChange={(e) => this.onChangeTransactionValues('side', e, index)}>
            <Option value="buy">Buy</Option>
            <Option value="sell">Sell</Option>
          </Select>
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'side')}>{text}</span>
        }
      }
    },{
      title: 'Quantity',
      width: '14%',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'quantity') {
          return <InputNumber value={text} onChange={(e) => this.onChangeTransactionValues('quantity', e, index)} />;
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'quantity')}>{text}</span>
        }
      }
    }, {
      title: 'UnderlyingSymbol',
      width: '14%',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (text) => {
        return <span style={{cursor: 'pointer'}} title={text}>{this.props.symbol}</span>
      }
    }, {
      title: 'Expiration',
      width: '14%',
      dataIndex: 'expiration',
      key: 'expiration',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'expiration') {
          return <DatePicker value={text ? moment(text) : ''} onChange={(e, string) => this.onChangeTransactionValues('expiration', string, index)} />;
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'expiration')}>{text}</span>
        }
      }
    }, {
      title: 'Strike',
      width: '14%',
      dataIndex: 'strike',
      key: 'strike',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'strike') {
          return <InputNumber value={text} onChange={(e) => this.onChangeTransactionValues('strike', e, index)} />;
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'strike')}>{text}</span>
        }
      }
    }, {
      title: 'Type',
      width: '14%',
      dataIndex: 'type',
      key: 'type',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'type') {
          return <Select defaultValue={text} value={text} onChange={(e) => this.onChangeTransactionValues('type', e, index)}>
                  <Option value="Call">Call</Option>
                  <Option value="Put">Put</Option>
                </Select>
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'type')}>{text}</span>
        }
      }
    }, {
      title: 'Market Price',
      dataIndex: 'price',
      width: '14%',
      key: 'price',
      render: (text, record, index) => {
        if (editIndex === index && editField === 'price') {
          return <InputNumber value={text} onChange={(e) => this.onChangeTransactionValues('price', e, index)} />;
        } else {
          return <span style={{cursor: 'pointer'}} onClick={() => this.editCell(index, 'price')}>{text}</span>
        }
      }
    },]
  }
  
  onAddItem = (item, askBid, type, event) => {
    event.stopPropagation();
    const {strike, call_Symbol, expiration, call_Ask, call_Bid, put_Ask, put_Bid, underlyingSymbol, underlyingPrice, multiplier} = item
    let {tableData} = this.state;
    let price = 0;
    if (type === 'Call') {
      price = (((call_Ask || 0) + (call_Bid || 0)) / 2);
    } else {
      price = (((put_Ask || 0) + (put_Bid || 0)) / 2);
    }
    if (!isNaN(price)) {
      price = parseFloat(price).toFixed(2)
    }
    const side = askBid === 'ask' ? 'buy' : 'sell';
    const quantity = askBid === 'ask' ? '1' : '-1';
    if (event.ctrlKey) {
      tableData.push({
        symbol: call_Symbol,
        type,
        side,
        expiration,
        quantity,
        strike,
        price,
        underlyingSymbol,
        underlyingPrice,
        multiplier
      });
    } else {
      tableData = [];
      tableData.push({
        symbol: call_Symbol,
        type,
        side,
        expiration,
        quantity,
        strike,
        price,
        underlyingSymbol,
        underlyingPrice,
        multiplier
      });
    }
    this.setState({
      tableData,
    });
  }
  
  onPin = () => {
    this.setState({
      pinned: !this.state.pinned,
    })
  }
  
  onDelete = () => {
    this.setState({
      tableData: [],
    });
  }
  
  onSend = () => {
    const {tableData} = this.state;
    if (tableData.length) {
      const selectedTrade = {};
      const today = moment().format('YYYY-MM-DD');;
      selectedTrade.symbols = this.props.symbol;
      selectedTrade.openDate =today;
      const transactions = [];
      tableData.forEach(data => {
        transactions.push({
          tradeDate: today,
          quantity: data.quantity,
          side: data.side,
          symbol: data.symbol,
          underlying: this.props.symbol,
          assetType: data.type,
          expiration: data.expiration,
          strike: !isNaN(data.strike) ? parseFloat(data.strike) : '',
          price: !isNaN(data.price) ? parseFloat(data.price) : '',
          mark: !isNaN(data.price) ? parseFloat(data.price) : '',
        });
      });
      selectedTrade.transactions = transactions;
      const jsonData = JSON.stringify(selectedTrade);
      localStorage.setItem('selectedTrade', jsonData);
    }
  }
  
  onUse = () => {
    const {tableData = []} = this.state;
    const transactions = [];
    const today = moment().format('YYYY-MM-DD');;
    tableData.forEach(data => {
      transactions.push({
        tradeDate: today,
        quantity: data.quantity,
        symbol: data.symbol,
        underlying: this.props.symbol,
        assetType: data.type,
        expiration: data.expiration,
        strike: !isNaN(data.strike) ? parseFloat(data.strike) : '',
        price: !isNaN(data.price) ? parseFloat(data.price) : '',
        mark: !isNaN(data.price) ? parseFloat(data.price) : '',
        underlyingSymbol: data.underlyingSymbol,
        underlyingPrice: data.underlyingPrice,
        multiplier: data.multiplier,
        side: data.side
      });
    });
    this.props.onCopyTransactions(transactions);
  }

  render() {
    const { optionBooks, isLoading, dataCount, collapseKey, nearestIndex, tableData = [], isTradeBuilder, pinned } = this.state;
    
    const columns = this.getColumns()

    return (
      <StyledOptonHader className={pinned && isTradeBuilder  ? 'pinned' : ''}>
        <div className="date-select">
          Select Date: <DatePicker value={this.state.onDate} onChange={this.onChangeDate} />
        </div>
          {isLoading ? <Spin className="col" size="large"/> :
            <div>
              <Sticky top={0}>
                <div className="bg-collheader">
                <div className="divrow">
                  <div style={{flex: 8}}>CALLS</div>
                  <div style={{flex: 2}}>
                    <Select value={dataCount} onChange={this.handleDataShow} size="small">
                      <Select.Option value="5">5</Select.Option>
                      <Select.Option value="10">10</Select.Option>
                      <Select.Option value="20">20</Select.Option>
                      <Select.Option value="50">50</Select.Option>
                      <Select.Option value="all">All</Select.Option>
                    </Select></div>
                  <div style={{flex: 8}}>PUTS</div>
                </div>
                <div className="divrow">
                  <div>Delta</div>
                  <div>Theta</div>
                  <div>Vega</div>
                  <div>IV</div>
                  <div>Volume</div>
                  <div>Open</div>
                  <div>Bid</div>
                  <div>Ask</div>
                  <div style={{flex: 2}}>Strike</div>
                  <div>Ask</div>
                  <div>Bid</div>
                  <div>Open</div>
                  <div>Volume</div>
                  <div>IV</div>
                  <div>Vega</div>
                  <div>Theta</div>
                  <div>Delta</div>
                </div>
              </div>
              </Sticky>
              <Collapse accordion bordered={false} onChange={this.onCollapse}>
                {
                  optionBooks ? optionBooks.map((data, i) => (
                    <Panel header={moment(data.expiration).format("DD MMM YY")} key={i + 1} >
                      {
                        collapseKey === i ? <OptionBookView onAddItem={this.onAddItem} nearestIndex={nearestIndex} stockPrice={this.state.stockPrice} books={data.asStraddles || []} dataCount={dataCount} /> : null
                      }
                    </Panel>
                  )) : null
                }
              </Collapse>
              {
                optionBooks.length === 0 && <div>No data found!</div>
              }
            </div>}
            {
              !isLoading && isTradeBuilder &&
               <div className="tradediv">
                 <h1>Trade Builder
                   <Icon type="close" onClick={() => this.setState({isTradeBuilder: false})} />
                   <Icon className='dock-Pin' type={pinned ? 'pushpin' : 'pushpin-o'} onClick={this.onPin} />
                 </h1>
                  <Table
                    dataSource={tableData}
                    rowSelection={false}
                    columns={columns}
                    size="small"
                    scroll={{ y: 200}}
                    pagination={false} />
                 {
                   this.props.isNewTrade ? <div className="footer">
                     <Button size="small" onClick={this.onUse} >Use Transactions</Button>
                   </div> :
                     <div className="footer">
                       <Button size="small">Copy</Button>
                       <Button size="small">Paste</Button>
                       <Button size="small" onClick={this.onDelete}>Delete</Button>
                       <Button size="small" onClick={this.onSend}>Send</Button>
                     </div>
                 }
                </div>
            }
            {
              !isLoading &&
              <Button type="primary" className="trade-btn" onClick={() => this.setState({isTradeBuilder: !isTradeBuilder})}>
                Trade Builder
              </Button>
            }
      </StyledOptonHader>
    )
  }
}

export default OptionBook



// WEBPACK FOOTER //
// ./src/components/option-book/index.js